import api from './api'
import { parseParams } from './common'

export default {
  getTarget ({ id, ...params }) {
    const urlParams = parseParams(params)
    return api.get(`/targets/${id}?${urlParams}`).then(res => res.data)
  },
  getTargets (params) {
    const urlParams = parseParams(params)
    return api.get(`/targets?${urlParams}`).then(res => res.data)
  },
  getAgeRange () {
    return api.get(`/targets/ages`).then(res => res.data)
  },
  getGenders () {
    return api.get(`/targets/genders`).then(res => res.data)
  },
  getTargetsInterests () {
    return api.get(`/targets/interests`).then(res => res.data)
  },
  createTarget (body) {
    return api.post(`/targets`, body).then(res => res.data)
  },
  editTarget ({ id, ...body }) {
    return api.put(`/targets/${id}`, body).then(res => res.data)
  },
  deleteTarget ({ id }) {
    return api.delete(`/targets/${id}`).then(res => res.data)
  }
}
